function getClerkPublishableKey(): string {
  const runtimeKey = window.__SHIPLEX_CONFIG__?.clerkPublishableKey;
  if (runtimeKey !== undefined) {
    return runtimeKey;
  }

  const buildTimeKey = String(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? '');
  if (buildTimeKey !== '') {
    return buildTimeKey;
  }

  throw new Error('Clerk publishable key not found. Ensure config.js is loaded or VITE_CLERK_PUBLISHABLE_KEY is set.');
}

export const runtimeConfig = {
  clerkPublishableKey: getClerkPublishableKey()
};
